<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons">Service Prequal</h4>
</div>
<div class="modal-body">
    <p *ngIf="!showPrequal">
        Redirecting to the transaction...
    </p>
    <transaction-prequal *ngIf="showPrequal"
        (changed)="handleEmit($event)"
        (cancel)="cancel()"
        [transactionValidationMode]="2"
        [validation]="validation"
        [transactionTypeId]="transactionTypeId"
        [customerNumberId]="customerNumberId"
        [serviceRequirementId]="serviceRequirementId"
        [aircraftId]="aircraftId"
        [businessTransactionParamId]="businessTransactionParamId"
        [businessTransactionParamTypeId]="businessTransactionParamTypeId">
    </transaction-prequal>
</div>